import { render, staticRenderFns } from "./CategoriesInsightsUs.vue?vue&type=template&id=76d3d92b&scoped=true&"
import script from "./CategoriesInsightsUs.vue?vue&type=script&lang=js&"
export * from "./CategoriesInsightsUs.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesInsightsUs.vue?vue&type=style&index=0&id=76d3d92b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d3d92b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
